import { AlertCircle, CheckCircle2, Info, X } from 'lucide-react'
import { useToastStore, type ToastItem } from '../../stores/toast'
import { cn } from '../../lib/utils'

const kindStyle: Record<ToastItem['kind'], { icon: typeof Info; cls: string }> = {
  success: { icon: CheckCircle2, cls: 'text-success' },
  error: { icon: AlertCircle, cls: 'text-critical' },
  info: { icon: Info, cls: 'text-watch' },
}

function ToastCard({ item }: { item: ToastItem }) {
  const { icon: Icon, cls } = kindStyle[item.kind]
  return (
    <div className="panel-glass pointer-events-auto flex w-80 items-start gap-2.5 rounded-lg p-3 shadow-xl">
      <Icon size={15} className={cn('mt-0.5 shrink-0', cls)} />
      <div className="min-w-0 flex-1">
        <div className="text-xs font-medium text-foreground">{item.title}</div>
        {item.description && <div className="mt-0.5 text-[11px] leading-4 text-muted-foreground">{item.description}</div>}
      </div>
      <button aria-label="关闭提示" onClick={() => useToastStore.getState().dismiss(item.id)} className="shrink-0 text-muted-foreground/60 hover:text-foreground">
        <X size={13} />
      </button>
    </div>
  )
}

export function Toaster() {
  const toasts = useToastStore((s) => s.toasts)
  if (toasts.length === 0) return null
  return (
    <div className="pointer-events-none fixed bottom-4 right-4 z-[100] flex flex-col gap-2">
      {toasts.map((t) => (
        <ToastCard key={t.id} item={t} />
      ))}
    </div>
  )
}
